import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => (width ? `${width}px` : '257px')};
  height: ${({ height }) => (height ? `${height}px` : '60px')};
  border-radius: 67.2px;
  font-family: BentonSans;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:disabled {
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
`;

// Primary button, in design system
const PurpleButton = styled(Button)`
  border-color: #9c0d63;
  background-color: #9c0d63;
  color: #ffffff;

  &:hover,
  &:focus {
    background-color: #790a4d;
    border-color: #6d0945;
  }
`;

export default PurpleButton;
